import React, { useEffect, useState } from "react";
import { getInfluencerDetail } from "../../../../store/affiliate/actions";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const InfluencerDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { influencerDetail, loading, totalCount } = useSelector(
    (state) => state.AffiliateContent,
  );
  useEffect(() => {
    fetchInfluencerDetail();
  }, [id]);

  const fetchInfluencerDetail = () => {
    if (!id) return;
    const callback = (err, response) => {
      if (err) {
        toast.error(err.message);
      } else {
        console.log("API response:", response);
      }
    };
    dispatch(getInfluencerDetail({ data: { id }, callback }));
  };

  return <div>Influencer Detail</div>;
};

export default InfluencerDetail;
